<template>
  <div class="csr">
    <page-wrapper :videoConfig="videoConfig">
      <template v-slot:main>
        <p>Our ecological commitment can be literally touched and smelled.</p>
        <p>Founded over a decade ago, the POPULAR Forest is a nature reserve with a rare biodiversity worth protecting.</p>
        <p>The forest binds more Co2 than we cause. This makes us the first sustainable and socially responsible agency in the world.</p>

<!--        <p>Located near Wismar, The POPULAR Forest was founded in 2012 and it’s home to many rare species of birds and insects. It absorbs more CO2 than our office creates, making us the first carbon neutral agency in Europe.</p>-->
      </template>
    </page-wrapper>
  </div>
</template>

<script>
  import PageWrapper from '@/components/PageWrapper'

  export default {
    name: 'Csr',
    components: {
      PageWrapper
    },
    data() {
      return {
        videoConfig: {
          srcL: require('../assets/video/Popular_Forrest_Website_Small.mp4'),
          posterL: require('../assets/video/Popular_Forrest_Website_Small.jpg'),
          srcM: require('../assets/video/Popular_Forrest_Website_Small.mp4'),
          posterM: require('../assets/video/Popular_Forrest_Website_Small.jpg'),
          srcS: require('../assets/video/Popular_Forrest_Website_Small.mp4'),
          posterS: require('../assets/video/Popular_Forrest_Website_Small.jpg')
        }
      }
    }
  }
</script>

<style></style>
